import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "days-container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
      return (_openBlock(), _createElementBlock("button", {
        class: _normalizeClass(`day-btn btn btn-secondary ${_ctx.selectedDays.includes(day.value) ? 'selected-day' : ''}`),
        key: day.value,
        onClick: ($event: any) => (_ctx.handleDaySelect(day.value))
      }, _toDisplayString(day.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}